module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.showBackground ? 'edit-pane' : ''
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 20,
      "lg": 20
    }
  }, [(_vm.deletable && !_vm.adding) ? _c('span', [_c('el-button', {
    attrs: {
      "type": _vm.deleteButtonType,
      "size": "mini",
      "icon": "fa fa-trash-alt",
      "round": _vm.deleteButtonType === 'text' ? false : _vm.round,
      "disabled": this.isViewOnly()
    },
    on: {
      "click": _vm.deleted
    }
  }, [(_vm.showButtonText) ? _c('span', {
    staticClass: "hidden-md-and-down"
  }, [_vm._v(" Delete")]) : _vm._e()]), _vm._v("  \n        ")], 1) : _vm._e(), _vm._v(" "), (_vm.title) ? _c('span', [(!_vm.titleHeading) ? _c('span', [_c('span', {
    staticClass: "text-info"
  }, [_vm._v(_vm._s(_vm.prefix) + ": ")]), _c('span', {
    staticClass: "text-primary",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })]) : _c(_vm.titleHeading, {
    tag: "span"
  }, [(_vm.prefix) ? _c('span', [_vm._v(_vm._s(_vm.prefix) + ": ")]) : _vm._e(), _vm._v(_vm._s(_vm.title))])], 1) : _c('span', [_vm._v("\n           \n        ")])]), _vm._v(" "), (_vm.adding || _vm.showEditButton) ? _c('el-col', {
    class: _vm.isMediumOrLess ? 'text-center' : 'text-right',
    attrs: {
      "span": 4
    }
  }, [(_vm.editMode && this.canChange()) ? _c('div', [_c('el-button', {
    attrs: {
      "type": "warning",
      "size": "mini",
      "icon": "fa fa-times-circle",
      "round": _vm.round
    },
    on: {
      "click": _vm.cancel
    }
  }, [(_vm.showButtonText) ? _c('span', {
    staticClass: "hidden-md-and-down"
  }, [_vm._v(" Cancel")]) : _vm._e()]), _vm._v(" \n          "), _c('el-button', {
    attrs: {
      "type": "success",
      "size": "mini",
      "icon": "fa fa-check",
      "round": _vm.round
    },
    on: {
      "click": _vm.save
    }
  }, [(_vm.showButtonText) ? _c('span', {
    staticClass: "hidden-md-and-down"
  }, [_vm._v("Save")]) : _vm._e()])], 1) : _c('div', [(_vm.editMode && this.canChange()) ? _c('div', [_c('el-button', {
    attrs: {
      "type": "warning",
      "size": "mini",
      "icon": "fa fa-times-circle",
      "round": _vm.round
    },
    on: {
      "click": _vm.cancel
    }
  }, [(_vm.showButtonText) ? _c('span', {
    staticClass: "hidden-md-and-down"
  }, [_vm._v(" Cancel")]) : _vm._e()]), _vm._v(" \n            "), _c('el-button', {
    attrs: {
      "type": "success",
      "size": "mini",
      "icon": "fa fa-check",
      "round": _vm.round
    },
    on: {
      "click": _vm.save
    }
  }, [(_vm.showButtonText) ? _c('span', {
    staticClass: "hidden-md-and-down"
  }, [_vm._v("Save")]) : _vm._e()])], 1) : _c('div', [(_vm.editable && !_vm.adding) ? _c('span', [_c('el-button', {
    attrs: {
      "type": _vm.editButtonType,
      "size": "mini",
      "icon": "fa fa-edit",
      "round": _vm.editButtonType === 'text' ? false : _vm.round,
      "disabled": this.isViewOnly()
    },
    on: {
      "click": _vm.edit
    }
  }, [(_vm.showButtonText) ? _c('span', {
    staticClass: "hidden-md-and-down"
  }, [_vm._v("  Edit")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.adding) ? _c('span', [_c('el-button', {
    attrs: {
      "type": _vm.addButtonType,
      "size": "mini",
      "icon": "fa fa-plus-circle",
      "round": _vm.addButtonType === 'text' ? false : _vm.round
    },
    on: {
      "click": _vm.add
    }
  }, [(_vm.showButtonText) ? _c('span', {
    staticClass: "hidden-md-and-down"
  }, [_vm._v("  Add")]) : _vm._e()])], 1) : _vm._e()])]), _vm._v(" "), _c('br')]) : _vm._e()], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "align": "start"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_vm._t("default")], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eaf72a18"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/EditPane.vue
// module id = 1647
// module chunks = 0